import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotificationStore } from '@/stores/notifications';
import logo from '@/assets/logo.png';
import spinner from '@/assets/spinner.gif';
import { CheckCircle, XCircle } from '@phosphor-icons/react';
import { useDownloadSharedTableAsCSV } from '../api/downloadSharedTableAsCSV';

const EmailCallback = () => {
  const navigate = useNavigate();
  const downloadCSV = useDownloadSharedTableAsCSV();
  const { addNotification } = useNotificationStore();

  let url = new URL(window.location.href);
  let params = new URLSearchParams(url.search);

  const messageId = url.href.substring(
    url.href.indexOf('report/') + 7,
    url.href.indexOf('/download')
  );

  const token = params.get('token');
  const reportName = params.get('ReportName');

  const [isLoading, setIsLoading] = useState('loading');

  const downloadTableAsCSV = async () => {
    try {
      const response = await downloadCSV?.mutateAsync({
        messageId: messageId,
        token: token,
      });
      if (response && response?.data && response.data?.link) {
        downloadFile(response?.data?.link, reportName);
        setIsLoading('success');
        addNotification({
          type: 'success',
          title: 'Table downloaded as CSV',
        });
      }
    } catch {
      setIsLoading('failure');
      addNotification({ type: 'error', title: 'Failed to download table' });
    }
  };

  const downloadFile = async (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (token === null || reportName === null) {
      navigate('/deep-dives');
    } else downloadTableAsCSV();
  }, []);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center">
          <img src={logo} className={`w-6 h-7`} />
          <span className="ml-3 text-xl text-pv-primary-primary-500 font-medium">
            Petavue
          </span>
        </div>
        {isLoading === 'loading' ? (
          <p>Downloading {reportName}</p>
        ) : isLoading === 'success' ? (
          <p>Downloaded {reportName}</p>
        ) : (
          <p>Failed to download {reportName}</p>
        )}
        {isLoading === 'loading' ? (
          <img src={spinner} alt="" className="w-5 h-5" />
        ) : isLoading === 'success' ? (
          <CheckCircle
            weight="fill"
            className="w-5 h-5 text-pv-success-success-text"
          />
        ) : (
          <XCircle weight="fill" className="w-5 h-5 text-pv-error-error-text" />
        )}
      </div>
    </div>
  );
};

export default EmailCallback;
